import localforage from 'localforage';

const getLocalStorage = () => {
  return localforage;
};

export const localAppStorage = getLocalStorage();
